import React from 'react';
import { Drawer, IconButton, makeStyles } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import { Close } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';
import useViewerDataContext from '../context/useVeiwerDataContext';
import useViewerApiContext from '../context/useViewerApiContext';

const DataRow = ({
  label,
  data,
  className
}: {
  label: string;
  data: string[];
  className?: string;
}) => {
  return (
    <div className={`row ${className}`}>
      <div className="row-label">
        <CustomizedTypography variant="body2" color="textSecondary">
          {label}
        </CustomizedTypography>
      </div>
      <div className="values">
        {React.Children.toArray(
          data.map((value) => (
            <CustomizedTypography variant="body2" color="textSecondary">
              {value}
            </CustomizedTypography>
          ))
        )}
      </div>
    </div>
  );
};

const MobileViewerDimensionsDrawer: React.FunctionComponent = () => {
  const { dimensionPaper, dimensionsHeader, dimensionsValues } = useStyles();
  const { dimensions } = useViewerDataContext();
  const { onCloseDimensions } = useViewerApiContext();
  const labels = ['X', 'Y', 'Z'];

  return (
    <Drawer
      classes={{ paper: dimensionPaper }}
      open={!!dimensions}
      onClose={onCloseDimensions}
      anchor="bottom"
    >
      <div className={dimensionsHeader}>
        <CustomizedTypography
          variant="body1"
          fontWeight="500"
          color="textPrimary"
        >
          치수정보
        </CustomizedTypography>

        <CustomizedTypography variant="subtitle2" color="textSecondary">
          Dimensions
        </CustomizedTypography>

        <IconButton
          size="medium"
          className="drawer-close-button"
          onClick={onCloseDimensions}
        >
          <Close size={24} color={colorSet.gray900} />
        </IconButton>
      </div>

      <div className={dimensionsValues}>
        <DataRow label="" data={labels} className="column-label" />
        <DataRow label="최소" data={dimensions?.minStrings ?? []} />
        <DataRow label="최대" data={dimensions?.maxStrings ?? []} />
        <DataRow label="크기" data={dimensions?.sizeStrings ?? []} />
        <div className="row volume">
          <CustomizedTypography variant="body2" color="textSecondary">
            추정 볼륨값
          </CustomizedTypography>
          <CustomizedTypography variant="body2" color="textSecondary">
            {dimensions?.volumeString}
          </CustomizedTypography>
        </div>
      </div>
    </Drawer>
  );
};

export default MobileViewerDimensionsDrawer;

const useStyles = makeStyles((theme) => ({
  dimensionPaper: {
    borderRadius: '16px 16px 0px 0px'
  },
  dimensionsHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
    borderBottom: `1px solid ${colorSet.gray200}`,
    gap: '6px',
    '& .drawer-close-button': {
      marginLeft: 'auto',
      padding: '6px'
    }
  },
  dimensionsValues: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 16px 16px',
    gap: '4px',
    '& .row': {
      display: 'flex',
      justifyContent: 'space-between',
      '&.column-label': {
        borderBottom: `1px solid ${colorSet.gray200}`,
        marginBottom: '4px',
        padding: '6px 0px'
      },
      '&.volume': {
        marginTop: '4px',
        paddingTop: '8px',
        borderTop: `1px solid ${colorSet.gray200}`
      },
      '& .row-label': {
        minWidth: 80
      },
      '& .values': {
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        '& p': {
          textAlign: 'right',
          '&.label': {
            textAlign: 'left'
          }
        }
      }
    }
  }
}));
